import { createAction } from 'redux-actions'
import * as actions from '../consts'

export const fetchUserCustomerInfo = createAction(actions.FETCH_USER_CUSTOMER_INFO)
export const fetchUserCustomerInfoSuccess = createAction(actions.FETCH_USER_CUSTOMER_INFO_SUCCESS)
export const fetchUserCustomerInfoFail = createAction(actions.FETCH_USER_CUSTOMER_INFO_FAIL)
